"use client"

import { useMediaQuery } from 'react-responsive';
import { useParams } from 'next/navigation';
import { Header } from './Header';
import { SearchListing } from '@/components/base/SearchListing';
import { ClientOnly } from '@/components/base/ClientOnly';

export function HeaderListingsContent() {
  const params = useParams();
  const isMobile = useMediaQuery({ query: '(max-width: 639px)' });

  return params.slug ? (
    <Header bgClass="listing-header">
      <div className="max-sm:hidden min-w-0 flex mx-auto">
        <SearchListing />
      </div>
    </Header>
  ) : (
    <Header bgClass="listing-header !fixed 3xl:left-1/2 3xl:-translate-x-1/2 3xl:w-full">
      <ClientOnly className="min-w-0 flex mx-auto max-sm:hidden header-wrap-box">
        {!isMobile && <SearchListing />}
      </ClientOnly>
    </Header>
  );
}
